import { LoginPageContent } from 'components/unified-login';
import { useIncomeInsuranceLoginPageContext } from 'context/income-insurance';
import { LoginPageLogicProvider } from 'context/income-insurance/LoginPageLogicProvider';

import styles from './Login.module.scss';
import { LOGIN_FORMS_MAP } from './login-forms.map';

const Page = () => {
  const context = useIncomeInsuranceLoginPageContext();

  return (
    <LoginPageContent
      {...context}
      loginFormsMap={LOGIN_FORMS_MAP}
      styles={styles}
    />
  );
};

const LoginPage = () => (
  <LoginPageLogicProvider>
    <Page />
  </LoginPageLogicProvider>
);

export default LoginPage;
